import Accordion from "./accordion/accordion"

export const Services = (props) => {
  const questionsAnswers = [
    {
      question: "How many Greyhounds will exist?",
      answer:
        "Initially there will be only 3333 unique greyhounds. We have plans to create a side story called The Cursed Greyhounds where only members (holding a greyhound) will be able to participate.",
    },
    {
      question: "Where can I get a Greyhound?",
      answer: "You can go to the secondary markets like jpg.store, CNFT.io, Genesis House, etc",
    },
    {
      question: "Is there any Roadmap?",
      answer: `Despite thinking that the NFT space is very dynamic and things change frequently we do have a development roadmap! Jump in our discord to check it out!`,
    },    
    {
      question: "What is The Greyhound Legends?",
      answer: `This event will happen after the minting process. Every member of the society will be able to participate no matter the amount of greyhounds, everybody will have the same chances. In The Founder's adventure he had contact with 7 legendary greyhounds, 7 unique NFTs that don't share any trait with other greyhounds. The Founder wrote in his journal moments of his adventure and also some clues for future members of the society to search and own this legends.`,
    },
    {
      question: "What is The Cursed Greyhound?",
      answer: `There is a main story about The Greyhound Society but we will be revealing a side story called The Cursed Greyhounds that will be a collection of 3333 Greyhounds as zombies, ghosts, demons and more. Only Greyhound holders will be elegible to participate in this minting and the price will be lower than the original collection.`,
    },
    {
      question: "What is The Hidden Chests?",
      answer: `You will be able to navigate freely in the Galgon Earth map and visit all the places, in your journey you will find words that that will be part of a Cardano wallet phrase, and inside that wallet ADA will be waiting for you.`,
    },
    {
      question: "The Greyhounds App?",
      answer: `We will be developing a mobile app where members will be able to participate in special events, The Founder Story and see their owned Grehounds.`,
    },
    {
      question: "What is the Greyhound Copyright?",
      answer: `All rights are reserved to The Greyhound Society team.`,
    },
    {
      question: "I'm interested but I have more questions!",
      answer: `Please join to our Discord server where we are online to answer any question or to receive any feedback!.`,
    },
  ];

  return (
    <div id="services">
      <div className="container">
        <div className="row">        
          <h2>FAQs</h2>
          <ul className="accordion">
            {questionsAnswers.map(({ question, answer }) => (
              <Accordion key={question} heading={question} content={answer} />
            ))}
          </ul>

        </div>
      </div>
    </div>
  )
}
